import { useEffect } from "react"
import { initClarity } from "../utils/clarity.ts"
import { useGetConfig } from "../api/config/get.ts"
import { useCookieConsent } from "./useCookieConsent.tsx"

export function useClarity() {
    const { data } = useGetConfig()
    const { decided, analytics } = useCookieConsent()

    useEffect(() => {
        // Microsoft Clarity is an analytics tracker — only load it once the user
        // has granted analytics consent.
        if (import.meta.env.MODE === 'production' && data?.CLARITY_ID && decided && analytics) {
            initClarity(data.CLARITY_ID)
        }
    }, [data?.CLARITY_ID, decided, analytics])
}
